"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MSG_TYPE_SET_ITEM = '@lepont/async-storage:setItem';
exports.MSG_TYPE_GET_ITEM = '@lepont/async-storage:getItem';
